import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ICopyAndEditAttachesData, ICopyAndEditAttachesScheme } from '@models/attaches/ICopyAndEditAttaches';

export class CopyAndEditAttachesService {
    static async fetchScheme(flowName: string): Promise<AxiosResponse<ICopyAndEditAttachesScheme, any>> {
        return $api.get<ICopyAndEditAttachesScheme>(`/document/copyAndEditAttachScheme/${flowName}`);
    }

    static async fetchData(
        docId: string,
        baseDocId: string,
        flowName: string,
    ): Promise<AxiosResponse<ICopyAndEditAttachesData, any>> {
        const documentId = docId ?? '-1';
        const ids = baseDocId?.split(',').filter((id) => id && id !== '-1') ?? [];
        return $api.post<ICopyAndEditAttachesData>(
            `/document/copyAndEditAttachData/${documentId}`,
            ids,
            {
                params: {
                    flowName: flowName,
                },
            },
        );
    }
}
